import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import type { MenuItemType } from '@shared/types/layout';
import { APP_MENU_NAVIGATION } from '../app-menu-navigation';

@Component({
  selector: 'li[app-menu-item]',
  host: { class: 'side-nav-item' },
  imports: [RouterLink],
  templateUrl: './app-menu-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppMenuItemComponent {
  readonly item = input.required<MenuItemType>();
  protected readonly nav = inject(APP_MENU_NAVIGATION);
}
